import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid, siteWide } from '@helpers/grid';
import styled from 'styled-components';
const Container = styled.section `
  padding: ${fluid(24, 40)} 0;
`;
const ColumnList = styled.ul `
  ${siteWide}
  ${baseGrid}
`;
const Column = styled.li `
  display: flex;
  flex-direction: column;

  &[data-layout='default'] {
    grid-column: span 6;
  }

  &[data-layout='wide'] {
    grid-column: span 14;
  }

  ${Container}[data-cards="true"][data-third="true"] & {
    &[data-layout='default'] {
      grid-column: span 5;
    }
  }
`;
const ColumnTitle = styled.span `
  display: block;
  ${fonts.apparat.semiBold}
  font-size: 18px;
  line-height: 28px;
  margin-bottom: ${fluid(16, 32)};
  text-transform: uppercase;
`;
const List = styled.ul `
  display: flex;
  flex-direction: column;

  ${Column}[data-layout='wide'] & {
    display: block;
    columns: 2;
    column-gap: var(--gutterWidth);
  }
`;
const Item = styled.li `
  display: block;
  break-inside: avoid;
  margin-bottom: ${fluid(6, 14)};
`;
const Link = styled.a `
  display: block;
  color: currentColor;
  text-decoration: none;
`;
const LinkTitle = styled.span `
  display: block;
  ${fonts.apparat.medium}
  font-size: 18px;
  line-height: 28px;

  ${Link}:focus &,
  ${Link}:hover & {
    text-decoration: underline;
  }
`;
const LinkSummary = styled.span `
  display: block;
  ${fonts.apparat.medium}
  font-size: 18px;
  line-height: 28px;
  margin-top: ${fluid(0, 4)};
  opacity: 0.5;
`;
const CardList = styled.div `
  display: grid;
  column-gap: var(--gutterWidth);
  grid-template-columns: 1fr 1fr;
`;
const CardItem = styled.div ``;
const DesktopNavigationDropdownStyles = {
    CardItem,
    CardList,
    Column,
    ColumnList,
    ColumnTitle,
    Container,
    Item,
    Link,
    LinkSummary,
    LinkTitle,
    List,
};
export default DesktopNavigationDropdownStyles;
